import { computed, makeObservable } from 'mobx'

import { Model } from 'modules/core/lib/mobx-rest'

import forms from 'modules/surveys/store/collections/forms'
import type Form from 'modules/surveys/store/models/Form'

interface IFormAccessGroupMembership {
  id: number
  access_id: number
  access_group_id: number
  form_id: number
}

class FormAccessGroupMembership extends Model<IFormAccessGroupMembership> {
  static urlRoot() {
    return '/surveys/access_groups'
  }

  constructor(attr: IFormAccessGroupMembership) {
    super(attr)
    makeObservable(this, {
      formAccessGroup: computed,
    })
  }

  get indexes() {
    return ['access_id', 'access_group_id', 'form_id']
  }

  get formAccessGroup(): Form | null | undefined {
    return forms.find({
      id: this.attributes.form_id,
    })
  }
}

export default FormAccessGroupMembership
